import React, { useEffect, useState } from 'react';
import { Modal, Input, Tooltip } from 'antd';

// import '@style/components/linkEditorPopup.scss';
import '../../../../../../styles/components/linkEditorPopup.scss';

const LINK_PLACE_HODLER = 'Edit Link';

// const truncateURLByDomain = (url) => {
//   return `${String(url || '').substring(0, 20)}...`;
// };

function isUrlValid(str) {
  try {
    const newUrl = new URL(str);
    return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
  } catch (err) {
    return false;
  }
}

const LinkEditorPopup = ({ value, onChange }) => {
  const [link, setLink] = useState(value);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onClose = () => {
    setIsModalOpen(false);
    setLink(value);
  };

  const isValidLink = String(link).length === 0 || isUrlValid(link);
  return (
    <>
      <Modal
        title="Edit Link"
        visible={isModalOpen}
        destroyOnClose
        icon={null}
        onOk={() => {
          onChange(link.replace(/[\r\n\t]/g, ''));
          setIsModalOpen(false);
        }}
        onCancel={onClose}
        okText="Save"
        wrapClassName="edit-link-modal"
        okButtonProps={{
          disabled: isValidLink === false,
        }}
      >
        <Input.TextArea
          value={link}
          onChange={(e) => {
            setLink(e.target.value);
          }}
          autoSize={{ maxRows: 8, minRows: 5 }}
          style={{ fontSize: '1rem' }}
        />
        {!isValidLink && (
          <span>
            Please enter a valid link that starts with either "http://" or
            "https://"
          </span>
        )}
      </Modal>
      <Tooltip title={link} placement="bottomLeft" autoAdjustOverflow="false">
        <span className="edit-link-label" onClick={() => setIsModalOpen(true)}>
          {value && value.length > 0 ? value : LINK_PLACE_HODLER}
        </span>
      </Tooltip>
    </>
  );
};

export default LinkEditorPopup;
